module.exports = __webpack_public_path__ + "img/zuofei.d094bc08.png";